export default __webpack_public_path__ + "static/media/summary_payments.281afdb3.png";